import NotificationsList from './NotificationsList'

const notificationRoutes = [{ path: '/notifications', component: NotificationsList }]

export default notificationRoutes
